import { Component, OnInit, Input, ElementRef, Renderer2 } from '@angular/core';
import { MenuItem, MenuService } from '../services/menu.service';
import { resolveMenuIcon, resolveGroupIcon } from '../services/menu-icons';
import * as _ from 'underscore';
@Component({
    // tslint:disable-next-line:component-selector
    selector: 'mega-menu',
    templateUrl: './mega-menu.component.html',
    styleUrls: ['./mega-menu.component.scss'],
    standalone: false
})
export class MegaMenuComponent implements OnInit {
  @Input() column: number;
  @Input() smenus: Array<MenuItem>;
  @Input() title: string[];
  @Input() menus: any[];
  constructor(private menuService: MenuService, private el: ElementRef, private renderer: Renderer2) {
    this.menus = [];
  }

  ngOnInit() {
    if (!!this.smenus) {

      if (this.menuService.items.length <= 3) {
        this.renderer.setStyle(this.el.nativeElement, 'left', '400px');
      }
      if (_.some(this.smenus, s => !!s.mmgroupBy)) {
        // Grouped megamenu (Reports): one titled column per mmgroupBy.
        const groupedMenus = _.groupBy(this.smenus, s => s.mmgroupBy + '#' + s.sortOrder);
        this.menus = Object.keys(groupedMenus).map(k => {
          const title = k.split('#')[0];
          // A megamenu head whose items carry no mmgroupBy groups under the
          // literal string "undefined" - show no column header rather than a
          // broken "undefined" label.
          const cleanTitle = (!title || title === 'undefined') ? '' : title;
          return { sortOrder: +k.split('#')[1], title: cleanTitle, menu: groupedMenus[k] };
        });
        this.menus = _.sortBy(this.menus, 'sortOrder');
      } else {
        // Flat list (Transaction / Administration / ...) that overflowed one
        // dropdown column: chunk it into untitled columns of rowsPerColumn
        // items IN DECLARED ORDER - the overflow simply continues in the
        // next column (owner directive 2026-07-23). Same figure as the
        // menu.service megamenu decision so a panel is never chunked into
        // a single column.
        const rows = MenuService.rowsPerColumn();
        const columns = [];
        for (let i = 0; i < this.smenus.length; i += rows) {
          columns.push({ sortOrder: columns.length, title: '', menu: this.smenus.slice(i, i + rows) });
        }
        this.menus = columns;
      }

    }

  }

  /** Relevant FA4 icon for a mega-menu leaf item. */
  iconFor(item: MenuItem): string {
    return resolveMenuIcon(item);
  }

  /** Relevant FA4 icon for a mega-menu column header (Pooja / Expense / Audit). */
  groupIcon(title: string): string {
    return resolveGroupIcon(title);
  }

}

